<div class="row grow flex-end advanced-search margin lrg bottom mat-elevation-z1">
  <div class="row grow flex-end padding all" [formGroup]="filterFormGroup">
    <div *ngFor="let filterControlName of filterControlNames">
      <input
        [formControlName]="filterControlName.control"
        class="margin left"
        [id]="filterControlName.control"
        #email
        matInput
        [placeholder]="filterControlName.label"
        [maxlength]="filterControlName.maxLength ?? ''"
        (focus)="setSearchFocus(filterControlName.control)"
      />
    </div>
  </div>
</div>
